// extracted by extract-css-chunks-webpack-plugin
module.exports = {"saved-items-page":"saved-items-page___Mbt_P","title":"title___3dpdP","grid":"grid___OiisF","heart":"heart___3ZS3J","startSearch":"startSearch___2ZnB7"};